import { render, staticRenderFns } from "./ADInfoList.vue?vue&type=template&id=2674da57&scoped=true"
import script from "./ADInfoList.vue?vue&type=script&lang=js"
export * from "./ADInfoList.vue?vue&type=script&lang=js"
import style0 from "./ADInfoList.vue?vue&type=style&index=0&id=2674da57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674da57",
  null
  
)

export default component.exports